module.exports = __webpack_public_path__ + "img/img-3.42d1a376.webp";